import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Voucher } from 'app/models/vouchers/voucher';
import { VoucherLetterUpload } from 'app/models/vouchers/voucher-letter-upload';
import { ParameterResultLetter } from 'app/models/well/samples/parameterResultLetter.viewmodel';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { VoucherService } from 'app/services/voucher-service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';

@Component({
  selector: 'exceedence-letter',
  templateUrl: './exceedence-letter.component.html',
  styleUrls: ['./exceedence-letter.component.scss']
})
export class ExceedenceLetterComponent implements OnInit {
  public environment = environment;
  voucher: Voucher = undefined;
  parameterResult: ParameterResultLetter = {
    analysisDate: '',
    analysisDatePlusYear: '',
    analysisMethod: '',
    analyte: '',
    contaminant: '',
    labName: '',
    id: 0,
    units: '',
    result: '',
    arsenic: '',
    hasEcoli: false,
    lead: '',
    hasTotalColiform: false,
    nitrate: '',
    nitrateNd: false,
    leadNd: false,
    arsenicNd: false,
    arsenicHigh: false,
    leadHigh: false,
    nitrateDisplay: '',
    createdDate: '',
    createdDatePlusYear: '',
    isRetest: false
  };
  processing: boolean = false;
  processingMessage: string = "";
  letter: VoucherLetterUpload = {
    id: 0,
    letterHtml: '',
    letterType: this.voucherService.exceedanceLetterType,
    parameterResultId: 0,
    sampleId: 0,
    voucherId: 0,
    letterContent: '',
    voucherApplicationId: 0,
    quarter: 0,
    year: 0,
    tier: 0,
    testType: '',
    testsRequired: '',
    retestId: 0,
    wellAddress: '',
    customerName: '',
    mailingAddress: '',
    mailingCity: '',
    mailingState: '',
    mailingZip: '',
    phone: '',
    email: '',
    voucherIdentifier: '',
    base64File: ''  
  };
  canSave: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: VoucherLetterUpload,
    private dialogRef: MatDialogRef<ExceedenceLetterComponent>,
    public voucherService: VoucherService,
    private toastr: ToastrService,
    public oregonWellDataService: OregonWellDataService) {
    this.letter = this.data;
  }

  ngOnInit(): void {
    this.loadVoucher();
  }

  loadVoucher() {
    this.processing = true;
    this.processingMessage = "Generating";
    this.voucherService.getVoucherById(this.letter.voucherId).subscribe(
      result => {
        this.voucher = result;
        this.voucherService.getParameterResultById(this.letter.parameterResultId).subscribe(
          serviceResult => {
            this.parameterResult = serviceResult;
            this.processing = false;
            this.processingMessage = "";
            this.canSave = true;
          },
          error => {
            console.log(error.error);
            this.toastr.error("Unable to load result");
            this.processing = false;
            this.processingMessage = "";
          }
        );
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
        this.toastr.error("Unable to load voucher");
      }
    );
  }

  onSubmit() {
    this.letter.letterHtml = this.oregonWellDataService.stripHtmlComments(document.getElementById('voucherLetterPdf').innerHTML);

    this.processing = true;
    this.processingMessage = "Saving Letter";
    this.voucherService.uploadLetter(this.letter).subscribe(
      result => {
        this.processingMessage = "";
        this.processing = false;
        this.toastr.success("Voucher Letter saved");
        this.dialogRef.close();
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
      }
    );
  }
}